import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { DraftsController } from "./drafts-controller";
import { DraftsPage } from "./drafts-page";

export function DraftsRoute({ deps }: { deps: AppDeps }) {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  // Bulk Scan is the scanner's Import now: an old link to it opens the scanner, whose Done lands here.
  if (params.get("bulk") === "1") return <Navigate to="/scan" replace />;
  return (
    <Subtree
      key="drafts"
      controller={() =>
        new DraftsController(
          pick(
            deps,
            "client",
            "authHandler",
            "storeRepository",
            "providersRepository",
            "reviewQueueRepository",
            "scanSessions",
          ),
          {
            reviewScan: (scanId, queue) => navigate(`/scans/${scanId}/edit`, { state: { returnTo: "/drafts", queue } }),
          },
        )
      }
    >
      <DraftsPage />
    </Subtree>
  );
}
